import { render, staticRenderFns } from "./DigitalAsset.vue?vue&type=template&id=a42cce76&scoped=true"
import script from "./DigitalAsset.vue?vue&type=script&lang=js"
export * from "./DigitalAsset.vue?vue&type=script&lang=js"
import style0 from "./DigitalAsset.vue?vue&type=style&index=0&id=a42cce76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42cce76",
  null
  
)

export default component.exports